import {
  CREATE_METAL_STREAM_BANK_ACCOUNT,
  CREATE_METAL_STREAM_BANK_ACCOUNT_SUCCESS,
  CREATE_METAL_STREAM_BANK_ACCOUNT_ERROR,
  CREATE_METAL_STREAM_AMOUNT,
  CREATE_METAL_STREAM_AMOUNT_SUCCESS,
  CREATE_METAL_STREAM_AMOUNT_ERROR,
  CREATE_METAL_STREAM_ALLOCATION,
  CREATE_METAL_STREAM_ALLOCATION_SUCCESS,
  CREATE_METAL_STREAM_ALLOCATION_ERROR,
  UPDATE_METAL_STREAM_ALLOCATION,
  UPDATE_METAL_STREAM_ALLOCATION_SUCCESS,
  UPDATE_METAL_STREAM_ALLOCATION_ERROR,
  GET_METAL_STREAM_PRODUCTS,
  GET_METAL_STREAM_PRODUCTS_SUCCESS,
  GET_METAL_STREAM_PRODUCTS_ERROR,
  GET_METAL_STREAM_GOLD_PRODUCTS,
  GET_METAL_STREAM_GOLD_PRODUCTS_SUCCESS,
  GET_METAL_STREAM_GOLD_PRODUCTS_ERROR,
  GET_METAL_STREAM_SILVER_PRODUCTS,
  GET_METAL_STREAM_SILVER_PRODUCTS_SUCCESS,
  GET_METAL_STREAM_SILVER_PRODUCTS_ERROR,
  CREATE_METAL_STREAM_PRODUCTS,
  CREATE_METAL_STREAM_PRODUCTS_SUCCESS,
  CREATE_METAL_STREAM_PRODUCTS_ERROR,
  UPDATE_METAL_STREAM_PRODUCTS,
  UPDATE_METAL_STREAM_PRODUCTS_SUCCESS,
  UPDATE_METAL_STREAM_PRODUCTS_ERROR,
  UPDATE_METAL_STREAM_AMOUNT,
  UPDATE_METAL_STREAM_AMOUNT_SUCCESS,
  UPDATE_METAL_STREAM_AMOUNT_ERROR,
  CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING,
  CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SUCCESS,
  CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_ERROR,
  UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING,
  UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SUCCESS,
  UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_ERROR,
} from './metalStreamActionConstants';

export const createMetalStreamBankAccount = (payload) => ({
  type: CREATE_METAL_STREAM_BANK_ACCOUNT,
  payload,
});

export const createMetalStreamBankAccountSuccess = (payload) => ({
  type: CREATE_METAL_STREAM_BANK_ACCOUNT_SUCCESS,
  payload,
});

export const createMetalStreamBankAccountError = (payload) => ({
  type: CREATE_METAL_STREAM_BANK_ACCOUNT_ERROR,
  payload,
});

export const updateMetalStreamAmount = (payload) => ({
  type: UPDATE_METAL_STREAM_AMOUNT,
  payload,
});

export const updateMetalStreamAmountSuccess = (payload) => ({
  type: UPDATE_METAL_STREAM_AMOUNT_SUCCESS,
  payload,
});

export const updateMetalStreamAmountError = (payload) => ({
  type: UPDATE_METAL_STREAM_AMOUNT_ERROR,
  payload,
});

export const createMetalStreamAmount = (payload) => ({
  type: CREATE_METAL_STREAM_AMOUNT,
  payload,
});

export const createMetalStreamAmountSuccess = (payload) => ({
  type: CREATE_METAL_STREAM_AMOUNT_SUCCESS,
  payload,
});

export const createMetalStreamAmountError = (payload) => ({
  type: CREATE_METAL_STREAM_AMOUNT_ERROR,
  payload,
});

export const createMetalStreamAllocation = (payload) => ({
  type: CREATE_METAL_STREAM_ALLOCATION,
  payload,
});

export const createMetalStreamAllocationSuccess = (payload) => ({
  type: CREATE_METAL_STREAM_ALLOCATION_SUCCESS,
  payload,
});

export const createMetalStreamAllocationError = (payload) => ({
  type: CREATE_METAL_STREAM_ALLOCATION_ERROR,
  payload,
});

export const updateMetalStreamAllocation = (payload) => ({
  type: UPDATE_METAL_STREAM_ALLOCATION,
  payload,
});

export const updateMetalStreamAllocationSuccess = (payload) => ({
  type: UPDATE_METAL_STREAM_ALLOCATION_SUCCESS,
  payload,
});

export const updateMetalStreamAllocationError = (payload) => ({
  type: UPDATE_METAL_STREAM_ALLOCATION_ERROR,
  payload,
});

export const createMetalStreamProducts = (payload) => ({
  type: CREATE_METAL_STREAM_PRODUCTS,
  payload,
});

export const createMetalStreamProductsSuccess = (payload) => ({
  type: CREATE_METAL_STREAM_PRODUCTS_SUCCESS,
  payload,
});

export const createMetalStreamProductsError = (payload) => ({
  type: CREATE_METAL_STREAM_PRODUCTS_ERROR,
  payload,
});

export const updateMetalStreamProducts = (payload) => ({
  type: UPDATE_METAL_STREAM_PRODUCTS,
  payload,
});

export const updateMetalStreamProductsSuccess = (payload) => ({
  type: UPDATE_METAL_STREAM_PRODUCTS_SUCCESS,
  payload,
});

export const updateMetalStreamProductsError = (payload) => ({
  type: UPDATE_METAL_STREAM_PRODUCTS_ERROR,
  payload,
});

export const getMetalStreamProducts = (payload) => ({
  type: GET_METAL_STREAM_PRODUCTS,
  payload,
});

export const getMetalStreamProductsSuccess = (payload) => ({
  type: GET_METAL_STREAM_PRODUCTS_SUCCESS,
  payload,
});

export const getMetalStreamProductsError = (payload) => ({
  type: GET_METAL_STREAM_PRODUCTS_ERROR,
  payload,
});

export const getMetalStreamGoldProducts = (payload) => ({
  type: GET_METAL_STREAM_GOLD_PRODUCTS,
  payload,
});

export const getMetalStreamGoldProductsSuccess = (payload) => ({
  type: GET_METAL_STREAM_GOLD_PRODUCTS_SUCCESS,
  payload,
});

export const getMetalStreamGoldProductsError = (payload) => ({
  type: GET_METAL_STREAM_GOLD_PRODUCTS_ERROR,
  payload,
});

export const getMetalStreamSilverProducts = (payload) => ({
  type: GET_METAL_STREAM_SILVER_PRODUCTS,
  payload,
});

export const getMetalStreamSilverProductsSuccess = (payload) => ({
  type: GET_METAL_STREAM_SILVER_PRODUCTS_SUCCESS,
  payload,
});

export const getMetalStreamSilverProductsError = (payload) => ({
  type: GET_METAL_STREAM_SILVER_PRODUCTS_ERROR,
  payload,
});

export const createMetalStreamBankApplicationFunding = (payload) => ({
  type: CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING,
  payload,
});

export const createMetalStreamBankApplicationFundingSuccess = (payload) => ({
  type: CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SUCCESS,
  payload,
});

export const createMetalStreamBankApplicationFundingError = (payload) => ({
  type: CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_ERROR,
  payload,
});

export const updateMetalStreamBankApplicationFunding = (payload) => ({
  type: UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING,
  payload,
});

export const updateMetalStreamBankApplicationFundingSuccess = (payload) => ({
  type: UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SUCCESS,
  payload,
});

export const updateMetalStreamBankApplicationFundingError = (payload) => ({
  type: UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_ERROR,
  payload,
});
